import { Injectable, Inject } from "@angular/core";
import { Router, Params } from "@angular/router";
import { APP_BASE_HREF } from "@angular/common";

@Injectable({
  providedIn: "root",
})
export class WindowService {
  constructor(
    @Inject(APP_BASE_HREF) private baseHref: string,
    private router: Router
  ) {}

  public openInNewPage(url: string, queryParams: Params = {}) {
    const fullUrl = this.router.serializeUrl(
      this.router.createUrlTree([url], { queryParams })
    );

    window.open(this.join(this.baseHref, fullUrl), "_blank");
  }

  public openInNewPageWithoutSerializeUrl(url: string, queryParams: Params = {}) { 
    window.open(this.join(this.baseHref, url), "_blank");
  }

  private join(...args: string[]): string {
    let components = [];

    /**
     * If an empty array is received then
     * the URL is just ''.
     */
    if (args.length === 0) {
      return "";
    }

    /** The args values must be of type string */
    args.forEach((component) => {
      if (typeof component !== "string") {
        throw new TypeError(
          `Url components must be of type string. 
                    The ${component} component is of type ${typeof component}`
        );
      }
    });

    /**
     * If the protocol is specified by itself,
     * then the protocol is combined with the
     * subsequent array value.
     */
    const protocol = args[0];

    if (protocol.match(/^[^/:]+:\/*$/) && args.length > 1) {
      let first = args.shift();
      args[0] = first + args[0];
    }

    /**
     * The file protocol should have two or three slashes.
     * Other protocols should have 2.
     */
    if (args[0].match(/^file:\/\/\//)) {
      args[0] = args[0].replace(/^([^/:]+):\/*/, "$1:///");
    } else {
      args[0] = args[0].replace(/^([^/:]+):\/*/, "$1://");
    }

    /** The args values must be of type string */
    args.forEach((component, i) => {
      if (component === "") {
        return;
      }

      /**
       * Remove starting slashes for all but the first component
       */
      if (i > 0) {
        component = component.replace(/^[\/]+/, "");
      }

      /**
       * Remove the ending slashes for each component but the last.
       */
      if (i < args.length - 1) {
        component = component.replace(/[\/]+$/, "");
      } else {
        // For the last combine multiple slashes into one.
        component = component.replace(/[\/]+$/, "/");
      }
      components.push(component);
    });

    /**
     * Separate all the components by a single /
     */
    let url = components.join("/");

    // remove trailing slash before parameters or hash
    url = url.replace(/\/(\?|&|#[^!])/g, "$1");

    // replace ? in parameters with &
    let parts = url.split("?");
    url = parts.shift() + (parts.length > 0 ? "?" : "") + parts.join("&");
    return url;
  }
}
